import {
  ADD_STEPS_CLEAR_STATE,
  FETCH_PUBLISHED_STEPS_FAILURE,
  FETCH_PUBLISHED_STEPS_SUCCESS,
  FETCH_PUBLISHED_STEPS,
  FETCH_IN_HOUSE_STEPS_BY_DATABASE,
  FETCH_IN_HOUSE_STEPS_BY_DATABASE_SUCCESS,
  FETCH_IN_HOUSE_STEPS_BY_DATABASE_FAILURE,
  HIDE_ADD_STEPS_DIALOG,
  SHOW_ADD_STEPS_DIALOG,
  FETCH_PREDICTED_STEPS,
  FETCH_PREDICTED_STEPS_SUCCESS,
  FETCH_PREDICTED_STEPS_FAILURE,
  FETCH_PREDICTED_STEPS_EXAMPLES_SUCCESS,
  FETCH_PREDICTED_STEPS_EXAMPLES_FAILURE,
  SET_SELECTED_INDEXES_BY_TAB,
  ADD_STEPS,
  ADD_STEPS_FAILURE,
  ADD_STEPS_SUCCESS,
} from '@Pages/RetroSynthesis/EditPlan/AddSteps/constants';

export const initialState = {
  addStepsDialogIsShown: false,
  error: undefined,
  published: undefined,
  predictedResponse: undefined,
  isPredictedLoading: false,
  selectedStep: undefined,
  selectedStepExamplesSearchData: undefined,
  // Selection
  selectedItemsByTab: {},
  isLoading: false,
  newRoute: null,
  // In-house
  inHouseResponseByDatabase: {},
  isInHouseLoadingByDatabase: {},
  selectedStepsData: {},
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_STEPS_CLEAR_STATE:
      return { ...initialState };
    case HIDE_ADD_STEPS_DIALOG:
      return { ...state, addStepsDialogIsShown: false };
    case SHOW_ADD_STEPS_DIALOG: {
      const newState = action.payload.cleanState ? initialState : state;
      return { ...newState, selectedStep: action.payload.selectedStep, addStepsDialogIsShown: true };
    }
    case FETCH_PUBLISHED_STEPS:
      return { ...state, isPublishedLoading: true };
    case FETCH_PUBLISHED_STEPS_SUCCESS:
      return { ...state, isPublishedLoading: false, publishedResponse: action.payload, error: undefined };
    case FETCH_PUBLISHED_STEPS_FAILURE:
      return { ...state, isPublishedLoading: false, error: action.payload, publishedResponse: undefined };
    case FETCH_IN_HOUSE_STEPS_BY_DATABASE: {
      const { databaseId } = action.payload;
      return {
        ...state,
        isInHouseLoadingByDatabase: {
          ...state.isInHouseLoadingByDatabase,
          [databaseId]: true,
        },
      };
    }
    case FETCH_IN_HOUSE_STEPS_BY_DATABASE_SUCCESS: {
      const { databaseId, response } = action.payload;
      return {
        ...state,
        isInHouseLoadingByDatabase: {
          ...state.isInHouseLoadingByDatabase,
          [databaseId]: false,
        },
        inHouseResponseByDatabase: {
          ...state.inHouseResponseByDatabase,
          [databaseId]: response,
        },
        error: undefined,
      };
    }
    case FETCH_IN_HOUSE_STEPS_BY_DATABASE_FAILURE: {
      const { databaseId, error } = action.payload;
      return {
        ...state,
        isInHouseLoadingByDatabase: {
          ...state.isInHouseLoadingByDatabase,
          [databaseId]: false,
        },
        inHouseResponseByDatabase: {
          ...state.inHouseResponseByDatabase,
          [databaseId]: undefined,
        },
        error,
      };
    }
    case FETCH_PREDICTED_STEPS:
      return { ...state, isPredictedLoading: true };
    case FETCH_PREDICTED_STEPS_SUCCESS:
      return { ...state, isPredictedLoading: false, predictedResponse: action.payload, error: undefined };
    case FETCH_PREDICTED_STEPS_FAILURE:
      Logger.error('RT Edit Plan Predicted Steps search error: ', action.payload.error);
      return { ...state, isPredictedLoading: false, error: action.payload.error, predictedResponse: action.payload.response };
    case FETCH_PREDICTED_STEPS_EXAMPLES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        selectedStepExamplesSearchData: data,
      };
    }
    case FETCH_PREDICTED_STEPS_EXAMPLES_FAILURE: {
      const { error } = action.payload;
      Logger.error('RT Edit Plan Predicted Examples search error: ', error);
      return {
        ...state,
        selectedStepExamplesSearchData: null,
        error,
      };
    }
    case SET_SELECTED_INDEXES_BY_TAB: {
      const { tab, selectedItems } = action.payload;
      return {
        ...state,
        selectedItemsByTab: {
          ...state.selectedItemsByTab,
          [tab]: selectedItems,
        },
      };
    }
    case ADD_STEPS:
      return { ...state, isLoading: true, newRoute: null };
    case ADD_STEPS_SUCCESS:
      return { ...state, isLoading: false, addStepsDialogIsShown: false, newRoute: action.payload };
    case ADD_STEPS_FAILURE:
      Logger.error('RT Edit Plan Add Steps error: ', action.payload);
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
}
